import { IOption } from "models/Form";

export const UPLOAD_CATEGORY: IOption[] = [
  { id: 1, label: "Signed Bill of Lading (Delivered)", value: "Signed Bill of Lading (Delivered)" },
  { id: 2, label: "Signed Bill of Lading (Pick-Up)", value: "Signed Bill of Lading (Pick-Up)" },
  { id: 3, label: "Rate Confirmation", value: "Rate Confirmation" },
  { id: 4, label: "Truck Order Not Used", value: "Truck Order Not Used" },
  { id: 5, label: "Invoice", value: "Invoice" },
  { id: 6, label: "Freight Bill", value: "Freight Bill" },
  { id: 7, label: "Fuel Advance", value: "Fuel Advance" },
  { id: 8, label: "Lumper Receipt", value: "Lumper Receipt" },
  { id: 9, label: "Detention Receipt", value: "Detention Receipt" },
  { id: 10, label: "Late Fee Receipt", value: "Late Fee Receipt" },
  { id: 11, label: "Other", value: "Other" }
];

export const CUSTOMER_CATEGORY: IOption[] = [
  { id: 1, label: "Shipper Acknowledgement", value: "Shipper Acknowledgement" },
  { id: 2, label: "Other", value: "Other" }
];

export const NEW_CARRIER_CATEGORY: IOption[] = [
  { id: 0, label: "License", value: "driver_license" },
  { id: 1, label: "Insurance", value: "insurance" },
  { id: 2, label: "Void Check", value: "voided_check" },
  { id: 3, label: "NOA", value: "noa" },
  { id: 4, label: "Other", value: "" }
];

export const ORDER_LIST = [
  {
    id: 0,
    name: "Newest First",
    managePay: "-created",
    history: "-created",
    assignedLoads: "-created"
  },
  {
    id: 1,
    name: "Oldest First",
    managePay: "created",
    history: "created",
    assignedLoads: "created"
  },
  {
    id: 2,
    name: "High to Low Amount",
    managePay: "-amount",
    history: "-amount",
    assignedLoads: "-amount"
  },
  {
    id: 3,
    name: "Low to High Amount",
    managePay: "amount",
    history: "amount",
    assignedLoads: "amount"
  }
];

export const CARRIER_FR_STATUS_LABELS: { [key in string]: string } = {
  incomplete: "Incomplete",
  document_issue: "Doc Issue",
  fuel_advance: "Fuel Advance",
  non_factored: "Non Factored",
  pending_originals: "Pending Originals",
  document_review: "Doc Review",
  hold: "Hold",
  new: "New",
  pending_noa: "Pending NOA",
  pending: "Pending",
  remote_approved: "Approved",
  paid: "Paid",
  declined: "Declined",
  closed: "Closed",
  all: "All"
};

export const BROKER_FR_STATUS_LABELS: { [key in string]: string } = {
  incomplete: "Incomplete",
  pending: "Pending",
  hold: "Hold",
  haulpay_review: "HaulPay Review",
  non_factored: "Non Factored",
  document_issue: "Document Issue",
  pending_originals: "Pending Originals",
  fuel_advance: "Fuel Advance",
  remote_approved: "Approved",
  carrier_paid: "Carrier Paid",
  invoice_paid: "Invoice Paid",
  paid: "Paid",
  declined: "Declined",
  all: "All"
};

export const COLOR_BY_STATUS: { [key in string]: string } = {
  // In Progress Statuses - ORANGE
  Pending: "text-pendingBorder border-pendingBorder",
  Hold: "text-pendingBorder border-pendingBorder",
  "Special Pending": "text-pendingBorder border-pendingBorder",
  "Pending NOA": "text-pendingBorder border-pendingBorder",
  "Pending Noa": "text-pendingBorder border-pendingBorder",
  New: "text-pendingBorder border-pendingBorder",
  "New NOA": "text-pendingBorder border-pendingBorder",
  "Document Review": "text-pendingBorder border-pendingBorder",
  "Doc Review": "text-pendingBorder border-pendingBorder",
  "HP Review": "text-pendingBorder border-pendingBorder",
  "HaulPay Review": "text-pendingBorder border-pendingBorder",
  // Incomplete - BLUE
  Incomplete: "text-info border border-info",
  // Action Required Statuses - RED
  "Pending Originals": "text-declinedBorder border border-declinedBorder",
  "Pending Delivery": "text-declinedBorder border border-declinedBorder",
  "Document Issue": "text-declinedBorder border border-declinedBorder",
  "Doc Issue": "text-declinedBorder border border-declinedBorder",
  "Fuel Advance": "text-declinedBorder border border-declinedBorder",
  // Declined - GREY
  Declined: "text-subtitle border border-subtitle",
  "Non Factored": "text-subtitle border border-subtitle",
  // Approved/Paid - GREEN
  Paid: "text-approvedBorder border border-approvedBorder",
  Closed: "text-approvedBorder border border-approvedBorder",
  "Invoice Paid": "text-approvedBorder border border-approvedBorder",
  "Carrier Paid": "text-approvedBorder border border-approvedBorder",
  Approved: "text-approvedBorder border border-approvedBorder",
  "Remote Approved": "text-approvedBorder border border-approvedBorder"
};

export const COLOR_BY_STATUS_FOR_MY_CARRIER: { [key in string]: string } = {
  pending: "text-pendingBorder border border-pendingBorder",
  declined: "text-declinedBorder border border-declinedBorder",
  declined_3_months: "text-declinedBorder border border-declinedBorder",
  declined_6_months: "text-declinedBorder border border-declinedBorder",
  do_not_contact: "text-info border border-info",
  approved: "text-approvedBorder border border-approvedBorder",
  needs_review: "text-info border border-info"
};
